module.exports = __webpack_public_path__ + "img/shipinhao.ce4c7beb.png";